import React from 'react';
import PropTypes from 'prop-types';
import ModalView from '../modalView';

import '../style.sass';

const EditCategory = (props) => {
  const { t } = props;
  return (
    <ModalView
      title={t('Edit Category')}
      titleAction={t('Save')}
      {...props}
    />
  );
};

EditCategory.propTypes = {
  t: PropTypes.func.isRequired,
};

export default EditCategory;
